import { toast } from "react-toastify";
import SidebarField from "../../../components/Sidebar/SidebarField";
import { FormField } from "../../../components/FormField";
import Button from "../../../components/Button";
import TextInput from "../../../components/TextInput";
import React from "react";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import { IoIosAddCircleOutline } from "react-icons/io";
import { InventoryApi } from "../../../apis/inventory.api";
import { productApi } from "../../../apis/ProductListing.apis";
import { useContext, useEffect, useState } from "react";
import LoaderContext from "../../../components/loader";
import Textarea from "../../../components/Textarea";
import masterApi from "../../../apis/master.api";

function AddGRV({ open, handleClose, data, getAllGRV }) {
  const { handleLoading } = useContext(LoaderContext);
  const [allProducts, setAllProducts] = useState([]);
  const [unitMasterData, setUnitMasterData] = useState([]);
  const [isFullWidth, setIsFullWidth] = useState(false);

  const initialValues = {
    dateOfReceipt: data?.dateOfReceipt || new Date().toISOString().split("T")[0],
    receivedFrom: data?.receivedFrom || "",
    orderReference: data?.orderReference || "",
    vendorLocation: data?.vendorLocation || "",
    receivedBy: data?.receivedBy || "",
    attachments: null,
    itemDetails: data?.itemDetails?.map((item) => ({
      itemCode: item?.itemCode?._id || item?.itemCode || "",
      itemDescription: item?.itemDescription || "",
      quantity: item?.quantity || 0,
      unit: item?.unit?._id || item?.unit || "",
      unitCost: item?.unitCost || 0,
      totalCost: item?.totalCost || 0,
      conditionOfGoods: item?.conditionOfGoods || "",
      comments: item?.comments || "",
    })) || [
      {
        itemCode: "",
        itemDescription: "",
        quantity: 0,
        unit: "",
        unitCost: 0,
        totalCost: 0,
        conditionOfGoods: "",
        comments: "",
      },
    ],
  };

  const getAllProducts = async () => {
    handleLoading(true);
    try {
      const res = await productApi.getAllApprovedProduct();
      setAllProducts(res.data?.data || []);
    } catch (err) {
      toast.error(err?.message || "Failed to load products");
    } finally {
      handleLoading(false);
    }
  };

  const getAllUnitMaster = async () => {
    handleLoading(true);
    try {
      const res = await masterApi.getAllUnitMaster({});
      const units = res?.data?.data?.map((item) => ({
        name: item?.name,
        _id: item?._id,
      })) || [];
      setUnitMasterData(units);
    } catch (err) {
      toast.error(err?.message || "Failed to load units");
    } finally {
      handleLoading(false);
    }
  };

  useEffect(() => {
    getAllProducts();
    getAllUnitMaster();
  }, []);

  const handleSubmit = async (values, { resetForm }) => {
    console.log("Submitting GRV:", values);

    try {
      const res = data
        ? await InventoryApi.updateGRV(data?._id, values)
        : await InventoryApi.createGRV(values);

      toast.success(data ? "GRV updated successfully" : "GRV created successfully");
      getAllGRV();
      // resetForm(); // Uncomment if you want to reset form after submit
      handleClose();
    } catch (error) {
      console.error("Error saving GRV:", error);
      toast.error(error?.message || "Failed to save GRV");
    }
  };

  if (!open) return null;

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      {({ values, setFieldValue }) => (
        <Form>
          <SidebarField
            handleClose={handleClose}
            title={data ? "Update Goods Receipt Voucher (GRV)" : "Add Goods Receipt Voucher (GRV)"}
            button1={<Button text="Cancel" type="button" onClick={handleClose} />}
            button2={<Button text="Submit" type="submit" />}
            setHeaderWdith={setIsFullWidth}
          >
            <div className="w-full flex flex-col gap-6 bg-transparent py-4 px-3">
              {/* Top Fields */}
              <div className={`grid ${isFullWidth ? "gap-6 grid-cols-2 p-6" : "grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"}`}>
                {data && (
                  <div>
                    <FormField label="Receipt Number">
                      <TextInput
                        name="receiptNumber"
                        value={data?.receiptNumber || ""}
                        disabled
                      />
                    </FormField>
                  </div>
                )}

                <div>
                  <FormField label="Date of Receipt">
                    <Field
                      name="dateOfReceipt"
                      type="date"
                      className="w-full p-2.5 border border-gray-300 rounded-md"
                    />
                    <ErrorMessage name="dateOfReceipt" component="div" className="text-red-600 text-xs mt-1" />
                  </FormField>
                </div>

                <div>
                  <FormField label="Received From">
                    <Field
                      name="receivedFrom"
                      className="w-full p-2.5 border border-gray-300 rounded-md"
                    />
                    <ErrorMessage name="receivedFrom" component="div" className="text-red-600 text-xs mt-1" />
                  </FormField>
                </div>

                <div>
                  <FormField label="Order Reference">
                    <Field
                      name="orderReference"
                      className="w-full p-2.5 border border-gray-300 rounded-md"
                    />
                  </FormField>
                </div>

                <div>
                  <FormField label="Vendor Location">
                    <Field
                      name="vendorLocation"
                      className="w-full p-2.5 border border-gray-300 rounded-md"
                    />
                  </FormField>
                </div>

                <div>
                  <FormField label="Received By">
                    <Field
                      name="receivedBy"
                      className="w-full p-2.5 border border-gray-300 rounded-md"
                    />
                  </FormField>
                </div>

                <div>
                  <FormField label="Attachments">
                    <Field name="attachments">
                      {({ form: { setFieldValue } }) => (
                        <input
                          type="file"
                          onChange={(e) => setFieldValue("attachments", e.target.files[0])}
                          className="w-full p-2 border border-gray-300 rounded-md"
                        />
                      )}
                    </Field>
                  </FormField>
                </div>
              </div>

              {/* Item Details Table */}
              <FieldArray name="itemDetails">
                {({ push, remove }) => (
                  <div className="border rounded-lg overflow-hidden bg-white shadow-sm">
                    <div className="bg-gray-100 px-4 py-3 font-semibold text-gray-700 border-b">
                      Items Received
                    </div>

                    <div className="overflow-x-auto">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                          <tr>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Product</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Description</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Quantity</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Unit</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Unit Cost</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Total Cost</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Condition</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Comments</th>
                            <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase"></th>
                          </tr>
                        </thead>

                        <tbody className="divide-y divide-gray-200">
                          {values.itemDetails.map((_, index) => (
                            <tr key={index} className="hover:bg-gray-50">
                              {/* Product */}
                              <td className="px-4 py-4">
                                <Field name={`itemDetails.${index}.itemCode`}>
                                  {({ field, form: { setFieldValue } }) => (
                                    <select
                                      {...field}
                                      value={field.value || ""}
                                      onChange={(e) => {
                                        const id = e.target.value;
                                        const product = allProducts.find(p => p._id === id);
                                        setFieldValue(`itemDetails.${index}.itemCode`, id || "");
                                        if (product) {
                                          setFieldValue(`itemDetails.${index}.itemDescription`, product.name || "");
                                        }
                                      }}
                                      className="w-full p-2.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    >
                                      <option value="">Select product</option>
                                      {allProducts.map((p) => (
                                        <option key={p._id} value={p._id}>
                                          {p.name}
                                        </option>
                                      ))}
                                    </select>
                                  )}
                                </Field>
                                <ErrorMessage name={`itemDetails.${index}.itemCode`} component="div" className="text-red-600 text-xs mt-1" />
                              </td>

                              {/* Description */}
                              <td className="px-4 py-4">
                                <Field
                                  name={`itemDetails.${index}.itemDescription`}
                                  placeholder="Item description / name"
                                  className="w-full p-2.5 border border-gray-300 rounded-md text-sm"
                                />
                                <ErrorMessage name={`itemDetails.${index}.itemDescription`} component="div" className="text-red-600 text-xs mt-1" />
                              </td>

                              {/* Quantity */}
                              <td className="px-4 py-4">
                                <Field
                                  name={`itemDetails.${index}.quantity`}
                                  type="number"
                                  min="1"
                                  className="w-full p-2.5 border border-gray-300 rounded-md text-sm"
                                />
                              </td>

                              {/* Unit */}
                              <td className="px-4 py-4">
                                <Field name={`itemDetails.${index}.unit`}>
                                  {({ field }) => (
                                    <select
                                      {...field}
                                      value={field.value || ""}
                                      className="w-full p-2.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    >
                                      <option value="">Select unit</option>
                                      {unitMasterData.map((u) => (
                                        <option key={u._id} value={u._id}>
                                          {u.name}
                                        </option>
                                      ))}
                                    </select>
                                  )}
                                </Field>
                                <ErrorMessage name={`itemDetails.${index}.unit`} component="div" className="text-red-600 text-xs mt-1" />
                              </td>

                              {/* Unit Cost */}
                              <td className="px-4 py-4">
                                <Field
                                  name={`itemDetails.${index}.unitCost`}
                                  type="number"
                                  step="0.01"
                                  min="0"
                                  className="w-full p-2.5 border border-gray-300 rounded-md text-sm"
                                />
                              </td>

                              {/* Total Cost */}
                              <td className="px-4 py-4">
                                <Field
                                  name={`itemDetails.${index}.totalCost`}
                                  type="number"
                                  step="0.01"
                                  min="0"
                                  className="w-full p-2.5 border border-gray-300 rounded-md text-sm"
                                />
                              </td>

                              {/* Condition */}
                              <td className="px-4 py-4">
                                <Field name={`itemDetails.${index}.conditionOfGoods`}>
                                  {({ field }) => (
                                    <select
                                      {...field}
                                      value={field.value || ""}
                                      className="w-full p-2.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    >
                                      <option value="">Select condition</option>
                                      <option value="grade1">Grade 1</option>
                                      <option value="grade2">Grade 2</option>
                                      <option value="grade3">Grade 3</option>
                                      <option value="grade4">Grade 4</option>
                                      <option value="grade5">Grade 5</option>
                                    </select>
                                  )}
                                </Field>
                                <ErrorMessage name={`itemDetails.${index}.conditionOfGoods`} component="div" className="text-red-600 text-xs mt-1" />
                              </td>

                              {/* Comments */}
                              <td className="px-4 py-4">
                                <Field
                                  name={`itemDetails.${index}.comments`}
                                  placeholder="Remarks / comments"
                                  className="w-full p-2.5 border border-gray-300 rounded-md text-sm"
                                />
                              </td>

                              {/* Remove */}
                              <td className="px-4 py-4 text-center">
                                <button
                                  type="button"
                                  onClick={() => remove(index)}
                                  className="text-red-600 hover:text-red-800 text-sm font-medium"
                                >
                                  Remove
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Add Item Button */}
                    <div className="p-4 bg-gray-50 border-t">
                      <button
                        type="button"
                        onClick={() =>
                          push({
                            itemCode: "",
                            itemDescription: "",
                            quantity: 0,
                            unit: "",
                            unitCost: 0,
                            totalCost: 0,
                            conditionOfGoods: "",
                            comments: "",
                          })
                        }
                        className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm rounded hover:bg-blue-700 transition"
                      >
                        <IoIosAddCircleOutline size={20} />
                        Add New Item
                      </button>
                    </div>
                  </div>
                )}
              </FieldArray>
            </div>
          </SidebarField>
        </Form>
      )}
    </Formik>
  );
}

export default AddGRV;